module.exports = __webpack_public_path__ + "static/media/sort-down.8bf0137e.svg";